/**
 * @file 配置控制
 * @author mengchen <mengchen@babytree-inc.com>
 */

const getHostEnv = function () {
  const host = location.host;
  if (host == 'h5-fe-article.babytree.com') {
    return 'online';
  }
  // pre
  if (host.indexOf('pre.fpm') > -1) {
    return 'pre';
  }
  // test
  if (host.indexOf('-test') > -1) {
    return 'test';
  }
  return 'local';
};

export const processEnv = {
  nodeEnv: process.env.NODE_ENV,
  // buildTimestamp: new Date(process.env.BUIDTIMESTAMP),
  // version: process.env.VERSION,
  // publicPath: process.env.PUBLICPATH,
  // rootPath: process.env.ROOTPATH,
  hostEnv: getHostEnv()
};

export const getStorePrefix = function () {
  return '@@babytree-tool-';
};

export function getGOHost(serviceNum='1') {
  // online
  if (processEnv.hostEnv === 'online') {
    return '//go.babytree.com/';
  }
  // pre
  if (processEnv.hostEnv === 'pre') {
    return '//go.pre.fpm.babytree.com/';
  }
  // test
  if (processEnv.hostEnv === 'test') {
    return `//go.${serviceNum}.babytree-test.com/`;
  }
  // local
  return `//go.${serviceNum}.babytree-test.com/`;
}
export function getPregHost() {
  // online
  if (processEnv.hostEnv === 'online') {
    return '//h5.babytree.com/';
  }
  // pre
  if (processEnv.hostEnv === 'pre') {
    return '//h5-1.babytree-test.com/';
  }
  // test
  if (processEnv.hostEnv === 'test') {
    return `//h5-1.babytree-test.com/`;
  }
  // local
  return `//h5-1.babytree-test.com/`;
}

export function getPHPHost(serviceNum='21') {
  // online
  if (processEnv.hostEnv === 'online') {
    return '//api.babytree.com/';
  }
  // pre
  if (processEnv.hostEnv === 'pre') {
    return '//api.pre.fpm.babytree.com/';
  }
  // test
  if (processEnv.hostEnv === 'test') {
    return `//${serviceNum}.babytree-test.com/`;
  }
  // local
  return `//${serviceNum}.babytree-test.com/`;
}

export function getNewMapHost() {
  // online
  if (processEnv.hostEnv === 'online') {
    return '//newmapi.babytree.com/';
  }
  // pre
  if (processEnv.hostEnv === 'pre') {
    return '//newmapi.babytree.com/';
  }
  // test
  if (processEnv.hostEnv === 'test') {
    return '//newmapi.babytree-test.com/';
  }
  // local
  return '//newmapi.babytree-test.com/';
}

export function getMapiWebHost() {
  // online
  if (processEnv.hostEnv === 'online') {
    return '//mapiweb.babytree.com/';
  }
  // pre
  if (processEnv.hostEnv === 'pre') {
    return '//mapiweb.pre.fpm.babytree.com/';
  }
  // test
  if (processEnv.hostEnv === 'test') {
    return '//mapiweb.babytree-test.com/';
  }
  // local
  return '//mapiweb.babytree-test.com/';
}

export function getABTestingHost() {
  // online
  if (processEnv.hostEnv === 'online') {
    return '//abtesting.babytree.com/';
  }
  // pre
  if (processEnv.hostEnv === 'pre') {
    return '//abtesting.babytree.com/';
  }
  // test
  if (processEnv.hostEnv === 'test') {
    return '//abtesting.babytree.com/';
  }
  // local
  return '//abtesting.babytree.com/';
}

export function getOpenHost() {
  // online
  if (processEnv.hostEnv === 'online') {
    return '//open.babytree.com/';
  }
  // pre
  if (processEnv.hostEnv === 'pre') {
    return '//open-21.babytree-test.com/';
  }
  // test
  if (processEnv.hostEnv === 'test') {
    return '//open-21.babytree-test.com/';
  }
  // local
  return '//open-21.babytree-test.com/';
}

export function getMeitunHost() {
  // online
  if (processEnv.hostEnv === 'online') {
    return '//m.meitun.com/';
  }
  // pre
  if (processEnv.hostEnv === 'pre') {
    return '//m.meitun-test.com/';
  }
  // test
  if (processEnv.hostEnv === 'test') {
    return '//m.meitun-test.com/';
  }
  // local
  return '//m.meitun-test.com/';
}

export function getWebviewHost() {
  // online
  if (processEnv.hostEnv === 'online') {
    return '//webview.babytree.com/';
  }
  // pre
  if (processEnv.hostEnv === 'pre') {
    return '//pre.fpm.babytree.com/';
  }
  // test
  if (processEnv.hostEnv === 'test') {
    return '//webview.21.babytree-test.com/';
  }
  // local
  return '//webview.21.babytree-test.com/';
}

/**
 *
 * https://h5-1.babytree-test.com/h5_fe_article/html/cando/index?
 * &client-baby-status=3
 * &enc-user-id=u194066745079
 * &idfa=BB7D9758-A393-488A-A6BA-B5C61C87AD68&babytree-app-id=pregnancy
 * &babytree-client-type=ios
 * &babytree-app-version=8.26.0
 * &babytree-app-mac=206f56d31cb57206776dda09f74a4df0fc59276b
 * &babytree-app-longitude=116.462216
 * &babytree-app-latitude=39.928028
 * &bpreg_brithday=2016-05-24
 * &bpreg-brithday=2016-05-24
 * &client-role=1¤t-baby-id=95312565
 * &babytree-app-imei=863454034143540
 */

export const QUERY_KEY_WHITE_MAP = {
  'babytree-app-id': 1,
  'babytree-app-latitude': 1,
  'babytree-app-longitude': 1,
  'babytree-app-mac': 1,
  'babytree-app-version': 1,
  'babytree-client-type': 1,
  'bpreg-brithday': 1,
  bpreg_brithday: 1,
  'client-baby-status': 1,
  'client-role': 1,
  'enc-user-id': 1,
  'babytree-app-device-model': 1,
  'current-baby-id': 1,
  prepare_status: 1,
  'android-id': 1,
  'babytree-app-imei': 1,
  tool_id: 1,
  idfa: 1,
  moblie_share_src: 1,
  share_pregst: 1,
  share_dest: 1,
  share_ts: 1,
  share_uid: 1,
  share_bd: 1,
  navigation_bar_hidden: 1,
  debug: 1
};

export const NEWVIEW_QUERY_KEY_WHITE_MAP = {
  navigation_bar_hidden: 1,
  from_tool_id: 1,
  forbid_scroll: 1,
};

export const NEW_WEBVIEW_QUERY = 'babytree-fe-webview';

window.__processEnv = processEnv;


export const getWLAOptions = function (WLA, Options) {
  let scheme = 'bbtlmtrp://com.babytree.lama';
  if (WLA && WLA.detector.os.name == 'ios') {
    scheme = 'lama://main';
  }
  return {
    scheme,
    pkgs: {
      yyb: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.babytree.apps.lama',
      ios: 'https://itunes.apple.com/cn/app/kuai-le-la-ma-bao-bao-shu/id628470263?ls=1',
      android: 'http://r.babytree.com/07zMxVQ',
      channel: {
        refcode: '20170706_live_down',
        url: 'http://r.babytree.com/07zMxVQ'
      }
    },
    landPage: 'https://m.babytree.com/app/lama/open.php',
    wta: {
      appid: '21',
      param: {},
      bid: '',
      tid: ''
    },
    onGuideOpen: (context2WLA, detector) => {
      const div = document.createElement('div');
      div.className = 'wla-guide-div';
      div.style.position = 'fixed';
      div.style.top = '0';
      div.style.left = '0';
      div.style.zIndex = '99999';
      div.style.width = '100vw';
      div.style.height = '100vh';
      div.style.textAlign = 'center';
      div.style.backgroundColor = 'rgba(0,0,0,0.7)';
      div.style.padding = '20px 10px';
      div.style.boxSizing = 'border-box';
      const img = document.createElement('img');
      img.style.width = '100%';
      // ios android
      img.src =
        detector.os.name == 'ios'
          ? '//videoplayer.babytreeimg.com/ios-pop-1di9h9jtn1sug19iu10fs1q9pg50b.png'
          : '//videoplayer.babytreeimg.com/android-pop-1di9h9jtn1vg75mldm9o2c1ovda.png';
      div.appendChild(img);
      document.body.appendChild(div);
      div.onclick = function () {
        div.remove();
      };
    },
    onLinkOpen: (context2WLA, detector) => {
      const { openScheme } = context2WLA;
      const { pkgs = {} } = context2WLA.options;
      const { channel = {} } = pkgs;
      let openUrl = openScheme;
      console.log('openUrl---', openUrl);
      return `https://topen.babytree.com?loadurl=${window.encodeURIComponent(
        openUrl
      )}&recall=${window.encodeURIComponent(
        channel.url || 'http://r.babytree.com/07zMxVQ'
      )}`;
    },
    onSchemeOpen: (context2WLA, detector) => {
      const { openScheme } = context2WLA;
      let openUrl = openScheme;
      return openUrl;
    },
    ...Options
  };
};
